import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=54b76a51&"
import script from "./PasswordChange.vue?vue&type=script&lang=ts&"
export * from "./PasswordChange.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordChange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports